import React from "react";
import styled from "styled-components";
import { Link } from "../";
const IconDelete = styled.svg`
  height: 14px;
  margin-right: 8px;
  margin-top: -1px;
  width: 12px;

  g {
    fill: ${props => props.theme.colors.action};
  }
`;

const PageLink = ({
  children,
  ...props
}) => {
  return React.createElement(Link, props, React.createElement(IconDelete, {
    viewBox: "0 0 12 14"
  }, React.createElement("g", {
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd",
    transform: "translate(-2.000000, -1.000000)"
  }, React.createElement("path", {
    d: "M4,2 L5,1 L11,1.00416306 L12,2 L14,2 L14,3 L2,3 L2,2 L4,2 Z M3,4 L13,4 L13,14 C13,14.5522847 12.5522847,15 12,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,4 Z M5,6 L5,13 L11,13 L11,6 L5,6 Z",
    id: "Combined-Shape"
  }))), children);
};

export const LinkDeleteIcon = styled(PageLink)`
  color: ${props => props.theme.colors.linkDeleteDefault};
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.linkDeleteHover};
    ${IconDelete} {
      g {
        fill: ${props => props.theme.colors.linkDeleteHover};
      }
    }
  }
  ${IconDelete} {
    g {
      fill: ${props => props.theme.colors.linkDeleteDefault};
    }
  }
`;
export const LinkDeleteIconReverse = styled(PageLink)`
  color: #ffffff;
  &:hover,
  &:focus {
    color: #ffffff;
    ${IconDelete} {
      g {
        fill: #ffffff;
      }
    }
  }
  ${IconDelete} {
    g {
      fill: #ffffff;
    }
  }
`;